import React from 'react'
import classnames from 'classnames'

import css from './index.module.scss'

const LayoutSidebar = ({
  children,
  minWidth = '13rem',
  rightForDesktop = false,
  rightForAll = false,
  swapOrder = false,
  classes,
}) => {
  return (
    <div
      className={classnames(
        css.layoutSidebar,
        {
          [css['layoutSidebar--right-for-desktop']]: rightForDesktop,
          [css['layoutSidebar--right-for-all']]: rightForAll,
          [css['layoutSidebar--swap-order']]: swapOrder,
        },
        classes
      )}
    >
      <div>
        {children.map((child, index) => {
          //
          if (index === 0 && !swapOrder)
            return <div style={{ minWidth }}>{child}</div>
          if (index === 1 && swapOrder)
            return <div style={{ minWidth }}>{child}</div>
          return <div>{child}</div>
        })}
      </div>
    </div>
  )
}

export default LayoutSidebar
